import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { SortAscending, SortDescending } from "@phosphor-icons/react"
import Filter from "../../../components/TableFilters"
import Loader from "../../../components/Loader"
import Pagination from "../../../components/Pagination"
import { useState } from "react"

export const OrdersTable = ({
  loading = false,
  data = [],
  sorting,
  onSortingChange,
  columns,
}) => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const table = useReactTable({
    columns,
    data: loading ? [] : data || [],
    manualPagination: false,
    enableManualSorting: true,
    manualFiltering: true,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    pageCount: Math.ceil((data?.length || 0) / pagination.pageSize),
    onPaginationChange: setPagination,
    onSortingChange,
    enableSortingRemoval: false,
    state: {
      sorting,
      pagination,
    },
  })
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border-l border-b border-r border-gray-200">
        <thead>
          {table.getHeaderGroups().map((headerGroup, idx) => (
            <tr
              key={headerGroup.id + "-" + idx}
              className="overflow-hidden relative overflow-x-auto"
            >
              {headerGroup.headers.map((column) => (
                <th
                  key={column.id}
                  className="px-4 py-3 border-b border-gray-200 bg-gray-100 align-top sticky top-0 text-sm"
                >
                  <div className="flex flex-col justify-start items-center">
                    <button
                      {...{
                        className: column.column.getCanSort()
                          ? "w-full select-none cursor-pointer flex justify-center items-center gap-1"
                          : "w-full",
                        onClick: column.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(
                        column.column.columnDef.header,
                        column.getContext()
                      )}
                      {{
                        asc: <SortAscending className="h-4 w-4" />,
                        desc: <SortDescending className="h-4 w-4" />,
                      }[column.column.getIsSorted()] ?? null}
                    </button>
                    {column.column.getCanFilter() ? (
                      <div className="mt-2">
                        <Filter column={column.column} />
                      </div>
                    ) : null}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {loading ? (
          <tbody>
            <tr>
              <td colSpan={table.getAllColumns().length}>
                <div className="py-10">
                  <Loader />
                </div>
              </td>
            </tr>
          </tbody>
        ) : (
          <>
            {data?.length > 0 ? (
              <tbody>
                {table.getRowModel().rows.map((row, idx) => (
                  <tr key={row.id + "-" + idx} className="hover:bg-gray-100">
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className="px-4 py-2 border-b border-gray-200 text-center"
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tr>
                <td colSpan={table.getAllColumns().length}>
                  <div className="mt-3 text-center py-10">No orders found</div>
                </td>
              </tr>
            )}
          </>
        )}
      </table>
      {!loading && data.length > 0 && <Pagination tableLib={table} />}
    </div>
  )
}

export default OrdersTable
